module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBold.4a1bc8d2.eot";